<template>
  <vetster-slide-over
    ref="slideOver"
    size="lg"
    container-classes="lg:h-auto"
    overflow-visible
    @after-enter="afterEnter"
  >
    <template #header>
      <vetster-slide-over-common-heading
        :header="$t('search.add-your-location')"
        :sub-header="$t('search.please-enter-your-location-area')"
        @close="close"
      />
    </template>
    <template #content>
      <vetster-location-search
        :countries="country"
        :locale="locale"
        :show-label="false"
        class="pb-10 lg:pt-4 lg:pb-14 px-standard"
        @location-selected="save"
      />
    </template>
  </vetster-slide-over>
</template>

<script>
import VetsterLocationSearch from '@/brand-components/GuidedSearch/VetsterLocationSearch';
import VetsterSlideOver from '@/brand-components/VetsterSlideOver';
import VetsterSlideOverCommonHeading from '@/brand-components/VetsterSlideOverCommonHeading';

export default {
  name: 'VetsterLocationSlideOver',

  components: {
    VetsterSlideOver,
    VetsterSlideOverCommonHeading,
    VetsterLocationSearch,
  },

  props: {
    country: {
      type: String,
      required: true,
    },
    locale: {
      type: String,
      default: null,
    },
  },

  methods: {
    afterEnter() {
      document.querySelector('.mapboxgl-ctrl-geocoder--input').focus();
    },
    close() {
      this.$refs.slideOver.close();
    },
    open() {
      this.$refs.slideOver.open();
    },
    save(data) {
      this.$store.commit('search/setTempInputs', data);
      this.$emit('location-selected');
      this.close();
    },
  },
};
</script>
